import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useRegStyles = makeStyles((theme: Theme) => ({
  description: {
    fontSize: theme.spacing(1.5),
    color: theme.palette.grey.A400,
    fontStyle: 'normal',
  },
  zIndex: {
    zIndex: 10,
  },
}))
